<template>
	<div>
		<div class="dashboard-widget-tabs mb-0">
			<div class="dashboard-widget-tabs-content padding-m" style="margin: 0;border: 0;padding: 0;">
				<h2>
					<i class="uil uil-create-dashboard"></i> {{ dashboard.title }}
					<i class="uil uil-edit-alt edit-dashboard-title show-widget-settings-modal" v-tooltip="'ویرایش داشبورد'" style="font-size: 18px;position: relative;top: 0;" v-if="editable" @click="open_dashboard_edit_modal()"></i>
				</h2>
				<div class="dashboard-widget-h-btns" v-if="editable" v-tooltip="'افزودن ویجت به داشبورد'">
					<a href="" class="m-left m-top tgju-btn tgju-btn-primary" @click.prevent="open_widgets_modal()">
						<i class="uil uil-plus-circle"></i> افزودن ویجت
					</a>
				</div>
				
				<div class="dashboard-widget-h-btns" v-if="!editable">
					<a href="" class="m-left m-top tgju-btn tgju-btn-success" v-tooltip="'ایجاد'" @click.prevent="open_dashboard_add_modal()">
						<i class="uil uil-plus-circle"></i> ایجاد
					</a>
					<a href="" class="m-left m-top tgju-btn tgju-btn-success" v-tooltip="'مدیریت'" @click.prevent="open_dashboard_list_modal()">
						<i class="uil uil-setting"></i> مدیریت
					</a>
				</div>

			</div>
         </div>
		<slot v-if="loading">
			<div class="text-center p-2">
				<div class="widget-loading"></div>
			</div>
		</slot>
		<slot v-else>
			<template v-if="widgets.length">
					<!-- باکس ویجت ها -->
					<draggable
						class="row tgju-widgets-row dashboard-widget-list widget-border-fix widget-padding" :class="{ 'dashboard-page-loader': loading }"
						v-model="widgets" group="widgets" @start="drag=true" @end="saveWidgetsSort()" ghost-class="drag-ghost" handle=".drag-move" tag="ul">
						<template v-for="item in widgets">
							<li class="tgju-widgets-block col-12 draggable-element" :class="item.sizeClass" :key="item.widget.id" :data-widget-type="item.widget.type" :data-widget-id="item.widget.id" :data-widget-size="item.widget.size">
								<div class="tgju-widget light">
									<div class="list-widget  list-row bold list-row-title">
										<div class="list-col l-item pointer hover head-color" v-tooltip="'جابجایی'" v-if="editable">
											<i class="uil uil-draggabledots drag-move"></i>
										</div>
										<div class="list-col l-title head-color" :class="{ 'dot': !editable }">
											<span>{{ item.widget.title }}</span>
										</div>
										<div class="list-col l-item pointer hover head-color" v-tooltip="'تنظیمات'" @click="configClicked(item.widget)" v-if="editable">
											<i class="uil uil-setting"></i>
										</div>
										<div class="list-col l-item pointer hover head-color" v-if="editable" @click="openWidgetResizer(item.widget.id)">
											<i class="uil uil-arrows-h-alt" v-tooltip="'تغییر‌اندازه'" :class="{ 'widget-resizer-show': item.resizerShow }">
												<div class="widget-resizer">
													<span class="widget-resizer-sm" @click="changeWidgetSize(item.widget.id, 'small')">کوچک</span>
													<span class="widget-resizer-md" @click="changeWidgetSize(item.widget.id, 'medium')">متوسط</span>
													<span class="widget-resizer-lg" @click="changeWidgetSize(item.widget.id, 'large')">بزرگ</span>
													<span class="widget-resizer-xl" @click="changeWidgetSize(item.widget.id, 'full')">کامل</span>
													<div></div>
												</div>
											</i>
										</div>
										<div class="list-col l-item pointer hover head-color" v-tooltip="'حذف'" v-if="editable" @click="removeWidget(item.widget.id)"><i class="uil uil-trash-alt remove-widget"></i></div>
									</div>
									<div class="tgju-widget-content full-padding dashboard-edit-item">
										<div class="tables-default normal overflow-unset dashboard-widget-min">
											<component v-bind:is="item.component" :widget="item.widget" :data="item.data" :editable="editable" :ref="`widget_${item.widget.id}`" wrapper="dashboard"></component>
										</div>
									</div>
								</div>
							</li>
						</template>
					</draggable>
			</template>
			
			<template v-else>
				<!-- در صورتی که ویجتی اد نشده بود این بخش نمایش باید داده شود -->
				<div class="row tgju-widgets-row widget-padding noWidget-block">
					<div class="col-12">
						<div class="noWidget noContent">
							<div>
								<i class="uil uil-layer-group-slash noContent-icon" aria-hidden="true"></i>
								<p class="noContent-title">در حال حاضر ویجتی برای نمایش وجود ندارد!</p>
								<p class="noContent-description">شما میتوانید براحتی از منوی بالا و دکمه افزودن ویجت ، ویجت های خود را
									اضافه نمایید.</p>
							</div>
						</div>
					</div>
				</div>
			</template>
		</slot>
	</div>
</template>

<script>
	// این ویو برای ویرایش داشبورد استفاده میشود
	import draggable from 'vuedraggable'

	export default {
		name: 'DashboardEdit',
		components: {
			draggable
		},
		data: function () {
			return {
				dashboards: [],
				dashboard: {
					id: null,
					user_id: null,
					title: '',
					type: null,
					default: false,
					created_at: null,
				},
				widgets: [],
				loading: true,
				editable: false,
				widgetLoad: true,
			}
		},

		mounted() {
			if ( typeof this.$router.currentRoute.params.id != 'undefined' ) {
				this.dashboard.id = this.$router.currentRoute.params.id;
			}

			this.editable = this.$router.currentRoute.meta.editable;

			this.loadDashboards();
		},

		methods: {
			loadDashboards() {
				let dashboards = this.$store.state.dashboards;
				if ( !dashboards.length ) {
					this.loading = false;
					return;
				}

				dashboards.forEach(dashboard => {
					if ( this.dashboard.id && dashboard.id == this.dashboard.id ) {
						this.dashboard = dashboard;
					} else if ( !this.dashboard.id && dashboard.default ) {
						this.dashboard = dashboard;
					}
				});

				this.dashboards = dashboards;

				if ( !this.dashboard.id && dashboards ) {
					this.dashboard = dashboards[0];
				}

				if ( this.dashboard.id ) {
					this.loadWidets();
				}
			},
			// این متد برای بارگذاری ویجت ها استفاده میشود
			loadWidets() {
				this.$helpers.getWidgets({ dashboard_id: this.dashboard.id }).then((widgets) => {
					widgets.forEach((item, index) => {
						if ( !item.component ) {
							widgets.splice(index, 1);
							return;
						}
						
						Vue.component(
							item.component,
							() => import(`@/components/${item.component}`)
						);
					});

					this.widgets = widgets;
					this.loading = false;
				});
			},
			// این متد برای هندل کردن سورت و ترتیب قرار گیری ویجت ها استفاده میشود
			saveWidgetsSort() {
				let sort = [];
				this.widgets.forEach(item => {
					sort.push(item.widget.id);
				});

				let api_data = {
					dashboard_id: this.dashboard.id,
					sort: JSON.stringify(sort),
				};

				this.$helpers.makeRequest('POST', '/dashboard/widget-sort', api_data).then(api_response => {
					this.$helpers.api_alert(api_response);

					if ( api_response.status == 200 ) {
						//
					}
				});
			},
			// از این متد جهت هندل کردن تغییر سایز ابعاد لی اوت ویجت استفاده میشود
			openWidgetResizer(id) {
				let index = this.getIndex(id);

				this.widgets[index]['resizerShow'] = !this.widgets[index]['resizerShow'];
			},
			// این متد جهت اعمال تغییرات سایز ویجت استفاده میشود
			changeWidgetSize(id, size) {
				let index = this.getIndex(id);

				let sizeClass = this.$helpers.widgetSize(size);
				this.widgets[index].widget.size = size;
				this.widgets[index].sizeClass = sizeClass;

				let widget = this.$helpers.unbindObject(this.widgets[index].widget);
				this.$helpers.saveWidget(widget);

				this.$root.$emit('widgetSizeChanged');
			},

			// از این متد جهت حذف کردن ویجت استفاده میشود 
			removeWidget(id) {
				this.$helpers.confirm('هشدار حذف!', {
					message: 'آیا از حذف این ویجت اطمینان دارید؟',
				}).then((confirmed) => {
					if ( confirmed ) {
						let index = this.getIndex(id);

						this.widgets.splice(index, 1);
						
						this.$helpers.makeRequest('DELETE', '/dashboard/widget-delete/' + id).then(api_response => {
							this.$helpers.api_alert(api_response);

							if ( api_response.status == 200 ) {
								this.$swal.fire({
									icon:"success",
									title:"ویجت با موفقیت حذف شد",
									showConfirmButton:!1,
									timer:2000
								});
							}else{
								this.$swal.fire({
									icon:"error",
									title:"مشکلی در حذف ویجت رخ داده است",
									showConfirmButton:!1,
									timer:2000
								});
							}
						});	
					}
				});
			},
			// این متد جهت هندل کردن و باز کردن مودال افزودن ویجت جدید استفاده میشود
			open_widgets_modal() {
				let callbackEvent = this.$router.currentRoute.name + '_addWidget_' + new Date().getTime();

				let modal_data = {
					modal: 'general_modal',
					callbackEvent,
					component: 'Widgets.vue',
					config: {
						title: 'افزودن ویجت',
						icon: 'uil uil-plus-circle with-icon',
						smallModal: false
					}
				};

				this.$root.$emit('open_modal', modal_data);

				this.$root.$on(callbackEvent, (response) => {
					this.$helpers.getWidgets({ widget_type: response.data.type, store: true, dashboard_id: this.dashboard.id }).then((widgets) => {
						widgets.forEach(item => {
							Vue.component(
								item.component,
								() => import(`@/components/${item.component}`)
							);

							this.widgets.push(item);
						});
					});
				});
			},
			// از این متد جهت بازکردن مودال افزودن داشبورد جدید استفاده میشود
			open_dashboard_add_modal() {
				let callbackEvent = this.$router.currentRoute.name + '_manageDashboards_' + new Date().getTime();

				let modal_data = {
					modal: 'general_modal',
					callbackEvent,
					component: 'DashboardAdd.vue',
					config: {
						title: 'افزودن داشبورد',
						icon: 'uil uil-plus-circle with-icon',
						smallModal: true,
						data: {
							dashboards: this.dashboards
						},
					}
				};

				this.$root.$emit('open_modal', modal_data);

				this.$root.$on(callbackEvent, (response) => {
					if ( response.action == 'addDashboard' ) {
						this.$store.commit('addDashboard', {dashboard: response.data.dashboard});
					}
				});
			},
			// از این متد جهت بازکردن مودال لیست داشبورد ها استفاده میشود 
			// وضعیت کنونی : غیرفعال و استفاده نمیشود
			open_dashboard_list_modal() {
				
				this.loadDashboards();

				let callbackEvent = this.$router.currentRoute.name + '_manageDashboard_list_' + new Date().getTime();

				let modal_data = {
					modal: 'general_modal',
					callbackEvent,
					component: 'DashboardList.vue',
					config: {
						title: 'مدیریت داشبورد ها',
						icon: 'uil uil-setting with-icon',
						smallModal: true,
						data: {
							dashboards: this.dashboards
						},
					}
				};

				this.$root.$emit('open_modal', modal_data);

				this.$root.$on(callbackEvent, (response) => {
					if ( response.action == 'removeDashboard' ) {
						this.$store.commit('removeDashboard', {id: response.data.id});
					}
				});
			},

			// از این متد جهت باز کردن مودال ویرایش عنوان داشبورد استفاده میشود
			open_dashboard_edit_modal() {
				let callbackEvent = this.$router.currentRoute.name + '_dashboardEdit_' + new Date().getTime();

				let modal_data = {
					modal: 'general_modal',
					callbackEvent,
					component: 'DashboardEdit.vue',
					config: {
						title: 'ویرایش داشبورد',
						icon: 'uil uil-edit-alt with-icon',
						smallModal: true,
						data: {
							dashboard: this.dashboard
						},
					}
				};

				this.$root.$emit('open_modal', modal_data);

				this.$root.$on(callbackEvent, (response) => {
					this.$store.commit('editDashboard', {dashboard: response.data.dashboard});
				});
			},

			getIndex(id) {
				let index;

				this.widgets.forEach((item, _index) => {
					if ( item.widget.id == id ) {
						index = _index;
					}
				});

				return index;
			},

			configClicked(widget) {
				this.$refs[`widget_${widget.id}`][0].open_settings_modal();
			}
		}
	}
</script>